import { useEffect } from 'react';

declare global {
    interface Window {
        OneSignal: any;
        OneSignalDeferred: any[];
    }
}

const OneSignalWrapper = () => {
    useEffect(() => {
        const accessCode = localStorage.getItem('access_code');

        if (
            typeof window !== 'undefined' &&
            accessCode &&
            accessCode.startsWith('MED')
        ) {
            window.OneSignalDeferred = window.OneSignalDeferred || [];

            window.OneSignalDeferred.push(async function () {
                await window.OneSignal.init({
                    appId: '22e6b20f-9809-4d45-9d01-3716b4ff0321',
                });
               
            });
        }
    }, []);

    return null;
};

export default OneSignalWrapper;